import script from "./app.vue?vue&type=script&setup=true&lang=ts"
export * from "./app.vue?vue&type=script&setup=true&lang=ts"

import "./app.vue?vue&type=style&index=0&id=33aaa8e2&lang=css"

const __exports__ = script;

export default __exports__